import { Component, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FormHelper } from '@forms';
import { UserService } from '@user';
import { __i18n } from '@localisation';
import { RoutingInfoService } from '@routing';
import { HttpHelperService } from '@http';
import { MessagesService, MessageType } from '@ui-messages';
import { Router } from '@angular/router';
import { StateService, States } from '@state';

@Component({
    selector: 'reset-password',
    templateUrl: './set.password.template.html',
    standalone: false
})
export class SetPasswordComponent {
    constructor(
        private formBuilder: FormBuilder,
        private formHelper: FormHelper,
        private user: UserService,
        private routingInfos: RoutingInfoService,
        private httpHelper: HttpHelperService,
        private messageService: MessagesService,
        private router: Router,
        private changeDetection: ChangeDetectorRef,
        private stateService: StateService
    ){
        const formGroupCofig: any = {
            password : ['', Validators.compose([Validators.required]) ],
            confirmPassword : ['', Validators.compose([Validators.required]) ]
        };

        this.changePasswordForm = this.formBuilder.group(formGroupCofig);

        const currentUser = this.user.getUser();
        if(currentUser){
            this.stateService.value(States.themeConfig).subscribe((themeConfig) => {
                if(!themeConfig){
                    return false;
                }
                this.mustAcceptTermsOfUse = currentUser.mustAcceptTermsOfUse;
                if(this.mustAcceptTermsOfUse){
                    this.changePasswordForm.addControl(
                        'acceptTermsOfUse',
                        new FormControl('', Validators.required)
                    );
                }

                return true;
            }).while.falsy();
        }
    }

    public changePasswordForm: FormGroup;

    public changePasswordError: string;

    public changePasswordButtonState: string;

    public mustAcceptTermsOfUse: boolean = false;

    public mailIsSended: boolean = false;

    public async changePassword(){
        this.changePasswordError = null;
        this.formHelper.markFormGroupTouched(this.changePasswordForm);
        const password = this.changePasswordForm.controls.password.value;
        const confirmPassword = this.changePasswordForm.controls.confirmPassword.value;
        const idParameter = this.routingInfos.getCurrentRoutingParams();

        if(password !== confirmPassword){
            this.changePasswordError = __i18n(
                'Password and password confirmation must be equal!',
                'landingpage.changepassword.error.text.equal'
            );
        }else if(this.mustAcceptTermsOfUse && !this.changePasswordForm.controls.acceptTermsOfUse.value){
            this.changePasswordError = __i18n(
                'Terms of use must be accepted!',
                'landingpage.changepassword.error.termsofuse.notaccepted'
            );
        }else{
            if(this.changePasswordForm.valid) {
                this.changePasswordButtonState = 'loading';
                try {
                    const result = await this.user.setPassword({
                        requestId: idParameter.id,
                        newPassword: password,
                        confirmPassword
                    });
                    //add message and navigate to login
                    this.messageService.addMessage({
                        type : MessageType.success,
                        text : __i18n('The password has been changed', 'landingpage.info.text.passwordchanged'),
                        target : 'landingpage'
                    });
                    this.router.navigateByUrl('/Login');
                } catch(e) {
                    this.changePasswordError = this.httpHelper.getErrorMessage(e) 
                        || __i18n('The password could not be changed, an error occurred.', 'landingpage.changepassword.error');
                } finally {
                    this.changePasswordButtonState = 'loaded';
                }
            }
        }
    }
}